module.exports = __webpack_public_path__ + "static/media/dev-3.a3edea27.png";